import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = {
  key: 0,
  class: "font-size-12-600"
}

import moment from "moment";
import {computed} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InstalmentsDetails',
  props: {
  order: {
    type: Object,
  },
  supplierOrder: {
    type: Object,
  },
  isPackage: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props;

const filteredInstalments = computed(() => {
  return props.order?.instalments.filter((instalment: any) => instalment.type !== 'product');
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (filteredInstalments.value.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Instalments"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInstalments.value, (instalment, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `instalment-${index}`,
        class: "d-flex justify-space-between"
      }, [
        _createElementVNode("p", {
          class: _normalizeClass([{'font-danger':instalment?.payment_status === 'not_paid' }, "font-size-12-600"])
        }, _toDisplayString(_unref(moment)(instalment.payment_due ? instalment.payment_due : instalment.created_at).format('DD MMMM YYYY')), 3),
        _createElementVNode("p", {
          class: _normalizeClass([{'font-danger':instalment?.payment_status === 'not_paid' }, "font-size-12-600"])
        }, _toDisplayString(__props.supplierOrder?.currency_symbol) + _toDisplayString(instalment.price), 3)
      ]))
    }), 128))
  ]))
}
}

})